import {convertGRank} from '@/lib/base/ranking.js';
import {TYPE} from '@/constant/studyTask.js';
import courseService from '@/services/course.js';
import dayjs from 'dayjs';

const mixinObject = {
  data() {
    return {
      coursePlanToNameMapping: {},
    };
  },
  methods: {
    getTypeName(task) {
      const type = task.type;
      const value = task.value;
      console.log(task);
      switch (type) {
        case TYPE.LADDER_GAME:
        case TYPE.LADDER_TSUME:
        case TYPE.LADDER_FUSEKI:
        case TYPE.LADDER_ENDGAME:
          return this.$t('天梯闖關');
        case TYPE.COURSE:
        case TYPE.GAME: {
          let course = null;
          if (value.coursePlanName) {
            course = this.$t(value.coursePlanName);
          } else {
            const coursePlan = task.coursePlan || value.coursePlan;
            course = this.coursePlanToNameMapping[coursePlan];
          }
          return this.$t('學習 - {course}', {course});
        }
        case TYPE.VERIFICATION:
          return this.$t('檢定');
        default:
          return '';
      }
    },
    getContent(task) {
      const type = task.type;
      const value = task.value;
      switch (type) {
        case TYPE.LADDER_GAME:
          return this.$t('下棋 Lv. {level} 通關', {level: value});
        case TYPE.LADDER_TSUME:
          return this.$t('做題 Lv. {level} 通關', {level: value});
        case TYPE.LADDER_FUSEKI:
          return this.$t('佈局 Lv. {level} 通關', {level: value});
        case TYPE.LADDER_ENDGAME:
          return this.$t('官子 Lv. {level} 通關', {level: value});
        case TYPE.COURSE: {
          const {day = 1} = value;
          return this.$t('觀看課程第 {num} 堂', {num: day});
        }
        case TYPE.GAME: {
          const {id: level, name} = value;
          return this.$t('打敗 {name} （Lv. {level}）', {
            name,
            level,
          });
        }
        case TYPE.VERIFICATION:
          const rankLabel = convertGRank(value);
          return this.$t('{rank} 通過', {rank: rankLabel});
        default:
          return '';
      }
    },
  },
  async mounted() {
    const now = dayjs().format('YYYY-MM-DD');
    const list = await courseService.getCoursePlansList(now);
    const coursePlanToNameMapping = {};
    list.forEach((coursePlan) => {
      coursePlanToNameMapping[coursePlan.id] = coursePlan.name;
    });
    this.coursePlanToNameMapping = coursePlanToNameMapping;
  },
};

export default mixinObject;
